import { PropsWithChildren } from "react";
import { useAuth } from "react-oidc-context";

export interface LoginButtonProps extends PropsWithChildren {
    onClick?: (() => void) | null
}

export const LoginButton = ({ children, onClick = null }: LoginButtonProps) => {

    const auth = useAuth();
    return (
        <div style={{ border: 'none', width: '100%', height: '100%' }} onClick={() => {
            auth.signinRedirect();
            onClick && onClick()
        }}>{children}</div>
    );
};